import type { TextLocalisation } from './en';

export const danishLocalisation: TextLocalisation = {
  invalidInput: 'Kortoplysningerne er ugyldige',
  klarnaNotSupported: 'Klarna kan ikke tilføjes her. Gå tilbage og vælg Klarna',
  networkIssue: 'Kan ikke kontakte {brand}, tjek din netværksforbindelse og prøv igen',
  unknownIssue: 'Noget gik galt',
  cardRefused: 'Kort afvist af din bank',
  payButton: 'Næste',
  checkoutTitle: 'Betal',
  checkoutCancel: 'Annuller',
  checkoutHeader: '{amount} til {merchant}',
  checkoutPay: 'Betal',
  closeButton: 'Luk',
  poweredBy: 'Drevet af',
  tryAgain: 'Prøv igen',
  unexpectedAuthorisation: 'Kortet kan ikke godkendes. Kontakt venligst kundeservice.',
  'creditCard.numberField.title': 'Kortnummer',
  'creditCard.numberField.placeholder': 'Kortnummer',
  'creditCard.numberField.invalid': 'Ugyldigt kortnummer',
  'creditCard.expiryDateField.title': 'Udløbsdato',
  'creditCard.expiryDateField.placeholder': 'MM/ÅÅ',
  'creditCard.expiryDateField.invalid': 'Ugyldig udløbsdato',
  'creditCard.expiryDateField.month': 'Måned',
  'creditCard.expiryDateField.month.placeholder': 'MM',
  'creditCard.expiryDateField.year.placeholder': 'ÅÅ',
  'creditCard.expiryDateField.year': 'År',
  'creditCard.cvcField.title': 'CVC / CVV',
  'creditCard.cvcField.placeholder': '123',
  'creditCard.oneClickVerification.invalidInput.title': 'Ugyldig CVC / CVV',
  'creditCard.cvcField.placeholder.3digits': '3 cifre',
  'error.title': 'Noget gik galt',
  'error.subtitle.redirect': 'Noget gik galt',
  'error.subtitle.payment': 'Betaling mislykkedes',
  'error.subtitle.refused': 'Betaling mislykkedes',
  'error.message.unknown': 'Noget gik galt',
  'error.va.gen.01': 'Dette felt er påkrævet',
  'error.va.gen.02': 'Der er noget galt her',
  'error.va.sf-cc-num.01': 'Ugyldigt kortnummer',
  'error.va.sf-cc-num.02': 'Dette kortnummer passer ikke til korttypen',
  'error.va.sf-cc-num.03': 'Dette kort understøttes ikke',
  'error.va.sf-cc-dat.01': 'Kortet er udløbet',
  'error.va.sf-cc-dat.02': 'Datoen er for langt ude i fremtiden',
  'fscp.error.payment-failed': 'Betaling mislykkedes',
  'fscp.error.timeout': 'Tiden er udløbet',
  'fscp.error.message.timeout': 'Betalingen var inaktiv for længe. Prøv venligst igen.',
  'fscp.error.unknown': 'Noget gik galt',
  'fscp.error.message.insufficientFunds':
    'Der er ikke penge nok på kortet. Prøv venligst et andet kort.',
  'fscp.error.message.invalidCard': 'Dit kort blev afvist.',
  'creditCard.encryptedCardNumber.aria.iframeTitle': 'Kortnummer',
  'creditCard.encryptedCardNumber.aria.label': 'Kortnummer',
  'creditCard.encryptedExpiryDate.aria.iframeTitle': 'Udløbsdato',
  'creditCard.encryptedExpiryDate.aria.label': 'Udløbsdato',
  'creditCard.encryptedExpiryMonth.aria.iframeTitle': 'Udløbsmåned',
  'creditCard.encryptedExpiryMonth.aria.label': 'Udløbsmåned',
  'creditCard.encryptedExpiryYear.aria.iframeTitle': 'Udløbsår',
  'creditCard.encryptedExpiryYear.aria.label': 'Udløbsår',
  'creditCard.encryptedSecurityCode.aria.iframeTitle': 'Sikkerhedskode',
  'creditCard.encryptedSecurityCode.aria.label': 'Sikkerhedskode',
  abortFailed: 'Kan ikke annullere betaling.',
};
